import React, { Component } from 'react'; 
import { AuthContext } from '../../auth/AuthHandler';
import { ReleaseTrackerDataService, softwareIdToName } from '../../data/ReleaseTrackerDataService';
import { Switcher, DataTable, BackButton } from './../../components/index';
import './FeatureBugs.css';

export const switcher = [['Implementing Features'],[' Known Bugs'],['Fixed Bugs']];
export const tableHeadFeatures = ['Reference', 'Name', 'Description'];
export const tableHeadKnownBugs = ['Reference', 'Name', 'Description', 'Workaround', 'Fixed In'];
export const tableHeadFixedBugs = ['Reference', 'Name', 'Description', 'Workaround'];


export default class FeatureBugs extends Component{

  static contextType = AuthContext

  constructor(props){
    super(props)

    this.state = {
      selected: false, 
      selectedItem: switcher[0],
    }

  }
  
  componentDidMount(){
    this.relTrackerService = new ReleaseTrackerDataService(this.context);
    const { url, name, version } = this.props.match.params;

    // check if this is firmware or software
    if (this.props.match.params["locks_or_peripherals"]) {
      // this is firmware
      const locks_or_peripherals = this.props.match.params["locks_or_peripherals"];
      this.relTrackerService.getFirmwareFamiliesFirmwareVersion(locks_or_peripherals, url, name, version).then(data => {
        this.onDataChanged(data);
      }).catch(err => {
        console.error(err);
      });
    } else {
      this.relTrackerService.getSoftwareVersion(softwareIdToName(url), name, version).then(data => {
        this.onDataChanged(data);
      }).catch(err => {
        console.error(err);
      });
    }
  }

  onDataChanged(data) {
    this.setState({
      data: data,
      selected: true,
      selectedItem: switcher[0],
    })
  }

  getHead(tableHead){
    if(tableHead === switcher[0]){
      return tableHeadFeatures
    }else if(tableHead === switcher[1]){
      return tableHeadKnownBugs
    }else{
      return tableHeadFixedBugs
    }
   
  }

  setSelectedTab(value){
    this.setState({ selected: true, selectedItem: value})
  }

  showSwitcherTable(switcher, v){
    return (
      <>
      {switcher.map(value => (
        <Switcher 
          key={value} 
          content={value} 
          value={value}
          selected={this.state.selected}
          selectedItem={this.state.selectedItem} 
          itemsLength={v[value.toString().replace(/ /g, '')].length}
          onClick={() => this.setSelectedTab(value)}
        />
      ))}
      <DataTable key={v.Code} tableHead={this.getHead(this.state.selectedItem)} data={v} selectedItem={this.state.selectedItem}/>
    </>
    )
  }

  render(){
    const { url, name, version } = this.props.match.params;
    if (!this.state.data) {
      return (<div></div>)
    }

    return(
      <div>
        <BackButton />
        <h2>{'Version '+version}</h2>
        <p className="fwName">{softwareIdToName(url)} {name}</p>
  
        {this.showSwitcherTable(switcher, this.state.data)}
      </div>
    )
  }
}
